export const GET_TEAMS = "coinshift/viewTeams/GET_TEAMS";
export const GET_TEAMS_SUCCESS = "coinshift/viewTeams/GET_TEAMS_SUCCESS";
export const GET_TEAMS_ERROR = "coinshift/viewTeams/GET_TEAMS_ERROR";
